import React from 'react'
import Layout from './Layout'
import { useProps } from './useProps'
import { Form } from 'antd'

export const UsersBulkUpdate = () => {
  const [form] = Form.useForm()

  return <Layout {...useProps(form)} />
}
